import type { RouteRecordRaw } from 'vue-router'
import routerNames from './routerNames'
import routerTitle from './RouterTitle'

const AuthRouter: RouteRecordRaw = {
  path: '/',
  component: () => import('@/layouts/AuthLayout.vue'),
  meta: {
    redirectIfToken: true
  },
  children: [
    {
      name: routerNames.LOGIN,
      path: 'login',
      component: () => import('@/views/Auth/LoginView.vue'),
      meta: {
        title: routerTitle.LOGIN
      }
    },
    {
      name: routerNames.REGISTER,
      path: 'register',
      component: () => import('@/views/Auth/RegisterView.vue'),
      meta: {
        title: routerTitle.REGISTER
      }
    },
    {
      name: routerNames.CONFIRM_MAIL,
      path: 'confirm',
      component: () => import('@/views/Auth/ConfirmMailView.vue'),
      meta: {
        title: routerTitle.CONFIRM_MAIL
      }
    },
    {
      name: routerNames.FORGOT_PASSWORD,
      path: 'forgot-password',
      component: () => import('@/views/Auth/ForgotView.vue'),
      meta: {
        title: routerTitle.FORGOT_PASSWORD
      }
    },
    {
      name: routerNames.CONFIRM_MAIL_FORGOT,
      path: 'confirm-forgot',
      component: () => import('@/views/Auth/ConfirmMailForgotView.vue'),
      meta: {
        title: routerTitle.CONFIRM_MAIL_FORGOT
      }
    },
    {
      name: routerNames.NEW_PASSWORD,
      path: 'new-password',
      component: () => import('@/views/Auth/NewPasswordView.vue'),
      meta: {
        title: routerTitle.NEW_PASSWORD
      }
    }
  ]
}

export default AuthRouter
